import { AccountInfoNewRelicAttributes } from './AccountInfoNewRelicAttributes';
import { NewRelicBrowserFactory } from './NewRelicBrowserFactory';

export { NewRelicBrowser } from './NewRelicBrowser';

export function createNewRelicBrowserFactory(subscribeFn) {
  return new NewRelicBrowserFactory(new AccountInfoNewRelicAttributes(subscribeFn));
}
